import { luscinia } from "../luscinia";

export default function reloadBootgrids() {
    ($(`.${luscinia.css.bootgrid}[data-luscinia-filtercolumnname=""]`) as any).bootgrid("reload");
}